import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var LinesPipe = (function () {
    function LinesPipe() {
    }
    LinesPipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.replace(/\r\n/g, '\n').split('\n')
            : text;
    };
    LinesPipe.decorators = [
        { type: Pipe, args: [{ name: 'lines' },] },
    ];
    /** @nocollapse */
    LinesPipe.ctorParameters = function () { return []; };
    return LinesPipe;
}());
export { LinesPipe };
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/lines.js
// module id = 280
// module chunks = 4